import React from 'react';

interface TimelineSectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromBlue: string;
            toPurple: string;
        };
    };
}

const TimelineSection: React.FC<TimelineSectionProps> = ({ highlightColor }) => {
    const timelineItems = [
        {
            title: 'Present',
            description: 'Today, CGM Sports supports NCAA teams by centralizing structured and unstructured data from wearables and performance testing. Our dashboard acts as a synchronization hub for Coaches, Performance Coaches, and their Athletes. Our intelligent performance layer factors in everything else impacting the team and delivers insights focused on injury prevention and optimal training load.'
        },
        {
            title: 'January 2025',
            description: 'By January 2025, CGM Sports faced a critical decision: Should we continue supporting competitors solely through networking and mentorship, or pivot to directly empowering teams? We chose to maintain our mentorship efforts while building an intelligent performance layer designed specifically to support teams at scale.'
        },
        {
            title: 'January 2024',
            description: 'By January 2024, CGM Sports had grown to over 100 college athlete mentors across 38 universities, helping hundreds of young athletes improve both on and off the field.'
        },
        {
            title: 'February 2023',
            description: 'CGM Sports launched in February 2023 in San Francisco, CA, connecting NCAA athletes with youth athletes to help them progress on and off the field. The organization originally grew out of the MIT Martin Trust Center and the Harvard Innovation Labs.'
        }
    ];

    return (
        <section className="pb-36 px-4 sm:px-6 lg:px-8 bg-black relative">
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/10 to-transparent pointer-events-none"></div>
            <div className="max-w-7xl mx-auto relative z-10">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center observe-fade opacity-0">CGM Timeline</h2>
                <p className="text-center mb-16 observe-fade opacity-0">Our journey supporting competitors in their pursuit of greatness.</p>
                <div className="space-y-8">
                    {timelineItems.map((item, index) => (
                        <div key={index} className="observe-fade opacity-0">
                            <div className="flex items-start gap-6">
                                <div 
                                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                                    style={{ backgroundColor: highlightColor.hover }}
                                >
                                    <span className="text-white font-bold">{index + 1}</span>
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
                                    <p className="text-gray-300 leading-relaxed">{item.description}</p>
                                </div>
                            </div>
                            {index < timelineItems.length - 1 && (
                                <div className="ml-6 mt-4 mb-4 w-0.5 h-8 bg-gray-700"></div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TimelineSection;

